import React from 'react';
import AppSufferer from './components';
import Layout from '../../layouts/index';

const Sufferer = () => {
    return (
        <Layout>
            <AppSufferer />
        </Layout>
    );
};

export default Sufferer;
